import { Progress } from 'antd';
import React, { FC, memo } from 'react';
import s from './index.module.scss';

interface ProgressItem {
  percent: number;
  description?: string;
}

interface ProgressBarProps {
  percent?: number;
  description?: string;
  revertSuccessColor?: boolean;
  type?: 'single' | 'double';
  items?: ProgressItem[];
}

export const ProgressBar: FC<ProgressBarProps> = memo((props) => {
  const { percent, description, revertSuccessColor = false, type = 'single', items = [] } = props;

  const getStrokeColor = (value: number): string => {
    if (value < 30) {
      return revertSuccessColor ? 'var(--success)' : 'var(--error)';
    }

    if (value < 80) {
      return 'var(--warn)';
    }

    return revertSuccessColor ? 'var(--error)' : 'var(--success)';
  };

  const renderLine = (item?: ProgressItem): Nullable<JSX.Element> => {
    if (!item) return null;

    return (
      <div className="flex items-center gap-2">
        <Progress
          percent={item.percent}
          strokeColor={getStrokeColor(item.percent || 0)}
          trailColor="var(--secondaryLight)"
          showInfo={false}
          className={s.innerProgress}
        />
        <div className="text-sm w-[40px] text-right">{item.percent}%</div>
      </div>
    );
  };

  if (type === 'single') {
    return (
      <div>
        <Progress
          className={s.progressBar}
          percent={percent}
          strokeColor={getStrokeColor(percent || 0)}
          trailColor="var(--secondaryLight)"
          showInfo={false}
        />
        <div className="font-normal text-sm text-primaryLight">{description}</div>
      </div>
    );
  }

  const [top, bottom] = items;

  return (
    <div>
      <div>
        {top?.description && <div className="text-sm text-primaryLight">{top.description}</div>}

        <div className="flex flex-col gap-0">
          {renderLine(top)}
          {renderLine(bottom)}
        </div>

        {bottom?.description && <div className="text-sm text-primaryLight">{bottom.description}</div>}
      </div>
    </div>
  );
});
